import ReportBrandImagery from './reportBrandImagery'
export default ReportBrandImagery
